var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"canvas-background"},[_c('canvas',{ref:"canvas",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }